import { Checkbox } from '@mantine/core'

const BooleanRender = function ({ value, defs, onChange }) {
  const { dataCheckDisabled } = defs || {}
  return (
    <Checkbox
      disabled={dataCheckDisabled}
      styles={{ input: { cursor: 'pointer' } }}
      value={value}
      checked={value}
      onChange={(e) => {
        onChange(e.target.checked)
      }}
    />
  )
}

export default BooleanRender
